export default __webpack_public_path__ + "static/media/8.ad41470a.svg";